__turbopack_context__.v({
  "progressBar": "FriendsInvitedProgress-module__lcncEG__progressBar",
  "progressBarSection": "FriendsInvitedProgress-module__lcncEG__progressBarSection",
});
